export class Adminattendancedetails {
  constructor() {
    this.message = 'Hello world';
  }
}
